import type { DefaultQueryError } from '@ahm/api-wrappers-core';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';

import { requestOTPAction } from '@/actions/request-otp';

interface SendOTPRequestBody {
  phone_number: string;
  recaptcha_token: string;
}

export interface SendOTPResponse {}

export const RequestOTPFn = async (
  body: SendOTPRequestBody
): Promise<SendOTPResponse> => {
  const result = await requestOTPAction(body);

  if (!result.success) {
    const error: any = new Error(result.message ?? 'Failed to request OTP');
    error.response = {
      data: result,
      status: result.status ?? 500,
    };
    throw error;
  }

  return result.data as SendOTPResponse;
};

export const useRequestOTP = (
  opts?: UseMutationOptions<
    SendOTPResponse,
    DefaultQueryError,
    SendOTPRequestBody
  >
) => {
  return useMutation<SendOTPResponse, DefaultQueryError, SendOTPRequestBody>({
    mutationFn: RequestOTPFn,
    ...opts,
  });
};
